import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-delete',
	path: '/secure/admin/DeleteFieldLayout!default.jspa',
};
